import { toast } from "react-toastify";
import { apiSlice } from "../api/apiSlice";

export const leaveApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLeaves: builder.query({
      query: () => ({
        url: `leave-application?query=all`,
      }),
      providesTags: ["Leaves"],
    }),

    getLeavesByStatus: builder.query({
      query: ({ status, page, count }) => ({
        url: `leave-application?page=${page}&count=${count}&status=${status}`,
      }),
      providesTags: ["LeaveByStatus"],
    }),

    getLeave: builder.query({
      query: (id) => ({
        url: `leave-application/${id}`,
      }),
      providesTags: ["Leave"],
    }),

    getLeaveHistory: builder.query({
      query: (id) => ({
        url: `leave-application/${id}/leaveHistory`,
      }),
      providesTags: ["LeaveHistory"],
    }),

    addLeave: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `leave-application/`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;

          toast.success("Leave added successfully");
        } catch (err) {
          toast.error("An error occurred while adding Leave");
        }
      },
      invalidatesTags: ["Leaves", "LeaveByStatus"],
    }),

    updateLeave: builder.mutation({
      query: ({ id, values }) => ({
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `leave-application/${id}`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;

          toast.success("Leave updated successfully");
        } catch (err) {
          toast.error("An error occurred while updating Leave");
        }
      },
      invalidatesTags: ["Leaves", "LeaveByStatus", "Leave"],
    }),

    reviewLeaveApp: builder.mutation({
      query: ({ id, values }) => ({
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `leave-application/${id}`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;

          toast.success("Leave updated successfully");
        } catch (err) {
          toast.error("An error occurred while updating Leave");
        }
      },
      invalidatesTags: ["Leaves", "LeaveByStatus", "Leave"],
    }),
  }),
});

export const {
  useGetLeavesQuery,
  useGetLeaveQuery,
  useAddLeaveMutation,
  useGetLeaveHistoryQuery,
  useUpdateLeaveMutation,
  useGetLeavesByStatusQuery,
  useReviewLeaveAppMutation,
} = leaveApi;
